export const ESSENTIAL_CARE_ROOT_PATH = '/preventive-care';
